// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared styles of the code-review pages; each page imports this file as a scoped style. */
.crRoot[data-v-b6a2e524]
{
	padding: 8px 8px 1em 8px;
	background-color: #EFEDE6;
	overflow-y: auto;
	flex: 1 1 auto;
	min-width: 0;
	font-size: 14px;
}
.pageHeading[data-v-b6a2e524]
{
	font-size: 28px;
	margin: 0 0 0.25em 0;
	font-weight: normal;
}
.secondaryHeading[data-v-b6a2e524]
{
	font-size: 18px;
	margin: 0 0 0.4em 0;
	font-weight: bold;
}
.tabs[data-v-b6a2e524]
{
	display: flex;
	gap: 4px;
	margin-bottom: 8px;
}
.tabs a[data-v-b6a2e524]
	{
		padding: 4px 12px;
		border: 1px solid #AAAAAA;
		background-color: #E8E8E8;
		color: #000000;
		text-decoration: none;
}
.tabs a.router-link-exact-active[data-v-b6a2e524],
		.tabs a.active[data-v-b6a2e524]
		{
			background-color: #FFFFFF;
			font-weight: bold;
}
.card[data-v-b6a2e524]
{
	border: 1px solid #DDDDDD;
	padding: 10px 12px;
	background-color: #FFFFFF;
	margin-bottom: 10px;
	box-shadow: 1px 1px 2px rgba(0,0,0,0.3);
}
.errorBox[data-v-b6a2e524]
{
	background-color: #FFE0E0;
	border: 1px solid #C00000;
	color: #660000;
	padding: 6px 10px;
	margin: 6px 0;
	white-space: pre-wrap;
	word-break: break-word;
}
.warningBox[data-v-b6a2e524]
{
	background-color: #FFEFC9;
	border: 1px solid #E0B93F;
	color: #5C3D00;
	padding: 6px 10px;
	margin: 6px 0;
}
.hintText[data-v-b6a2e524]
{
	color: #505050;
	font-size: 0.92em;
}
.row[data-v-b6a2e524]
{
	display: flex;
	flex-wrap: wrap;
	gap: 6px 10px;
	align-items: center;
	margin: 4px 0;
}
.loadingInline[data-v-b6a2e524]
{
	display: inline-flex;
	align-items: center;
	gap: 8px;
}
.badge[data-v-b6a2e524]
{
	display: inline-block;
	padding: 1px 6px;
	border-radius: 3px;
	font-size: 12px;
	font-weight: bold;
	white-space: nowrap;
	border: 1px solid transparent;
}

/* Severity badges: every pair has a contrast ratio of at least 4.5:1. */
.sevCritical[data-v-b6a2e524]
{
	background-color: #8B0000;
	color: #FFFFFF;
}
.sevHigh[data-v-b6a2e524]
{
	background-color: #B33C00;
	color: #FFFFFF;
}
.sevMedium[data-v-b6a2e524]
{
	background-color: #FFD24D;
	color: #3A2C00;
	border-color: #C9A227;
}
.sevLow[data-v-b6a2e524]
{
	background-color: #E4E4E4;
	color: #222222;
	border-color: #BBBBBB;
}

/* Security findings: a dark badge with a shield, so they stand out from the severity and status colors. */
.securityBadge[data-v-b6a2e524]
{
	background-color: #2D1457;
	color: #FFFFFF;
	border-color: #2D1457;
}
.securityBadge[data-v-b6a2e524]::before
	{
		content: "\\1F6E1\\FE0E\\00A0";
}

/* Status badges. */
.stFailed[data-v-b6a2e524]
{
	background-color: #B00000;
	color: #FFFFFF;
}
.stSafety[data-v-b6a2e524]
{
	background-color: #6A1B9A;
	color: #FFFFFF;
}
.stOpen[data-v-b6a2e524]
{
	background-color: #E2ECFA;
	color: #123A70;
	border-color: #9DB8D8;
}
.stProgress[data-v-b6a2e524]
{
	background-color: #FFF4D6;
	color: #5C3D00;
	border-color: #E0B93F;
}
.stDone[data-v-b6a2e524]
{
	background-color: #E3F2E3;
	color: #1B5E20;
	border-color: #9CC79C;
}
.stNeutral[data-v-b6a2e524]
{
	background-color: #EEEEEE;
	color: #333333;
	border-color: #BBBBBB;
}
.dense[data-v-b6a2e524]
{
	border-collapse: collapse;
	width: 100%;
	background-color: #FFFFFF;
	font-size: 13px;
}
.dense th[data-v-b6a2e524],
	.dense td[data-v-b6a2e524]
	{
		border-bottom: 1px solid #E2E2E2;
		padding: 3px 6px;
		text-align: left;
		vertical-align: top;
}
.dense th[data-v-b6a2e524]
	{
		background-color: #F0F0F0;
		position: sticky;
		top: 0;
		white-space: nowrap;
		z-index: 1;
}
.dense tbody tr.clickable[data-v-b6a2e524]
	{
		cursor: pointer;
}
.dense tbody tr.clickable[data-v-b6a2e524]:hover
		{
			background-color: #F4F8FF;
}
.nowrap[data-v-b6a2e524]
{
	white-space: nowrap;
}
.mono[data-v-b6a2e524]
{
	font-family: Consolas, monospace;
}
.fileCell[data-v-b6a2e524]
{
	font-family: Consolas, monospace;
	overflow-wrap: anywhere;
	min-width: 200px;
	max-width: 360px;
}
.titleCell[data-v-b6a2e524]
{
	min-width: 220px;
}
.infoTable[data-v-b6a2e524]
{
	border-collapse: collapse;
}
.infoTable th[data-v-b6a2e524]
	{
		text-align: left;
		padding: 2px 14px 2px 0;
		font-weight: normal;
		color: #444444;
		vertical-align: top;
		white-space: nowrap;
}
.infoTable td[data-v-b6a2e524]
	{
		padding: 2px 0;
		word-break: break-word;
}
.preText[data-v-b6a2e524]
{
	white-space: pre-wrap;
	word-break: break-word;
}
.scrollPre[data-v-b6a2e524]
{
	max-height: 400px;
	overflow: auto;
	background-color: #F7F7F7;
	border: 1px solid #DDDDDD;
	padding: 8px;
	font-size: 12px;
	white-space: pre-wrap;
	word-break: break-word;
	margin: 4px 0;
}
button[data-v-b6a2e524]:focus-visible,
a[data-v-b6a2e524]:focus-visible,
input[data-v-b6a2e524]:focus-visible,
select[data-v-b6a2e524]:focus-visible,
textarea[data-v-b6a2e524]:focus-visible,
summary[data-v-b6a2e524]:focus-visible,
tr[data-v-b6a2e524]:focus-visible
{
	outline: 2px solid #1A5FB4;
	outline-offset: 1px;
}

/* Action buttons, color-coded by kind (the label always says what it does; the color only groups):
   danger = closes or dismisses, positive = resolves or approves, caution = starts autonomous work now, assist = AI help, plain = neutral. */
.crAction[data-v-b6a2e524]
{
	font: inherit;
	padding: 3px 10px;
	border: 1px solid #8A8A8A;
	border-radius: 4px;
	background-color: #F2F2F2;
	color: #1A1A1A;
	cursor: pointer;
}
.crAction[data-v-b6a2e524]:hover:not(:disabled)
	{
		filter: brightness(0.94);
}
.crAction[data-v-b6a2e524]:disabled
	{
		opacity: 0.55;
		cursor: default;
}
.crAction.danger[data-v-b6a2e524]
	{
		background-color: #F8D7DA;
		border-color: #B02A37;
		color: #58151C;
}
.crAction.positive[data-v-b6a2e524]
	{
		background-color: #D1E7DD;
		border-color: #146C43;
		color: #0A3622;
}
.crAction.caution[data-v-b6a2e524]
	{
		background-color: #FFF3CD;
		border-color: #997404;
		color: #4D3A02;
}
.crAction.assist[data-v-b6a2e524]
	{
		background-color: #DCE8F7;
		border-color: #2B5797;
		color: #0F2A52;
}

/* Slide buttons (SlideButton.vue) for actions that are expensive or hard to undo; the handle color gives the kind as above.
   The class sits on the slider's root element. */
.crSlide[data-v-b6a2e524]
{
	--su-size-text: 13px;
	--su-color-bg: #F2F2F2;
}
.crSlide[data-v-b6a2e524] .slideunlock-text
	{
		padding-left: 30px;
		white-space: nowrap;
}
.linkButton[data-v-b6a2e524]
{
	background: none;
	border: none;
	padding: 0;
	color: #0B57A6;
	text-decoration: underline;
	cursor: pointer;
	font: inherit;
}
a[data-v-b6a2e524]
{
	color: #0B57A6;
}

/* Modal dialogs (reject, prompt). */
.overlay[data-v-b6a2e524]
{
	position: fixed;
	inset: 0;
	background-color: rgba(0, 0, 0, 0.45);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 1000;
}
.dialog[data-v-b6a2e524]
{
	background-color: #FFFFFF;
	padding: 14px 16px;
	width: 520px;
	max-width: calc(100vw - 32px);
	max-height: calc(100vh - 32px);
	overflow: auto;
	box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);
	box-sizing: border-box;
}
.dialogLabel[data-v-b6a2e524]
{
	font-weight: bold;
	display: block;
	margin: 8px 0 4px 0;
}
.reasonButtons[data-v-b6a2e524]
{
	display: flex;
	flex-wrap: wrap;
	gap: 6px;
}
.reasonButton[data-v-b6a2e524]
{
	padding: 4px 10px;
	border: 1px solid #888888;
	background-color: #F4F4F4;
	cursor: pointer;
}
.reasonButton.selected[data-v-b6a2e524]
	{
		background-color: #123A70;
		border-color: #123A70;
		color: #FFFFFF;
}
.resizable[data-v-b6a2e524]
{
	resize: both;
	min-height: 4em;
}
.dialogButtons[data-v-b6a2e524]
{
	margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./www/vues/client/codereview/codeReview.css"],"names":[],"mappings":"AAAA,2FAA2F;AAC3F;;CAEC,wBAAwB;CACxB,yBAAyB;CACzB,gBAAgB;CAChB,cAAc;CACd,YAAY;CACZ,eAAe;AAChB;AACA;;CAEC,eAAe;CACf,oBAAoB;CACpB,mBAAmB;AACpB;AACA;;CAEC,eAAe;CACf,mBAAmB;CACnB,iBAAiB;AAClB;AACA;;CAEC,aAAa;CACb,QAAQ;CACR,kBAAkB;AACnB;AACA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,qBAAqB;AACvB;AACA;;;GAGG,yBAAyB;GACzB,iBAAiB;AACpB;AACA;;CAEC,yBAAyB;CACzB,kBAAkB;CAClB,yBAAyB;CACzB,mBAAmB;CACnB,uCAAuC;AACxC;AACA;;CAEC,yBAAyB;CACzB,yBAAyB;CACzB,cAAc;CACd,iBAAiB;CACjB,aAAa;CACb,qBAAqB;CACrB,sBAAsB;AACvB;AACA;;CAEC,yBAAyB;CACzB,yBAAyB;CACzB,cAAc;CACd,iBAAiB;CACjB,aAAa;AACd;AACA;;CAEC,cAAc;CACd,iBAAiB;AAClB;AACA;;CAEC,aAAa;CACb,eAAe;CACf,aAAa;CACb,mBAAmB;CACnB,aAAa;AACd;AACA;;CAEC,oBAAoB;CACpB,mBAAmB;CACnB,QAAQ;AACT;AACA;;CAEC,qBAAqB;CACrB,gBAAgB;CAChB,kBAAkB;CAClB,eAAe;CACf,iBAAiB;CACjB,mBAAmB;CACnB,6BAA6B;AAC9B;;AAEA,wEAAwE;AACxE;;CAEC,yBAAyB;CACzB,cAAc;AACf;AACA;;CAEC,yBAAyB;CACzB,cAAc;AACf;AACA;;CAEC,yBAAyB;CACzB,cAAc;CACd,qBAAqB;AACtB;AACA;;CAEC,yBAAyB;CACzB,cAAc;CACd,qBAAqB;AACtB;;AAEA,0GAA0G;AAC1G;;CAEC,yBAAyB;CACzB,cAAc;CACd,qBAAqB;AACtB;AACA;;EAEE,2BAA2B;AAC7B;;AAEA,mBAAmB;AACnB;;CAEC,yBAAyB;CACzB,cAAc;AACf;AACA;;CAEC,yBAAyB;CACzB,cAAc;AACf;AACA;;CAEC,yBAAyB;CACzB,cAAc;CACd,qBAAqB;AACtB;AACA;;CAEC,yBAAyB;CACzB,cAAc;CACd,qBAAqB;AACtB;AACA;;CAEC,yBAAyB;CACzB,cAAc;CACd,qBAAqB;AACtB;AACA;;CAEC,yBAAyB;CACzB,cAAc;CACd,qBAAqB;AACtB;AACA;;CAEC,yBAAyB;CACzB,WAAW;CACX,yBAAyB;CACzB,eAAe;AAChB;AACA;;;EAGE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,mBAAmB;EACnB,UAAU;AACZ;AACA;;EAEE,eAAe;AACjB;AACA;;GAEG,yBAAyB;AAC5B;AACA;;CAEC,mBAAmB;AACpB;AACA;;CAEC,gCAAgC;AACjC;AACA;;CAEC,gCAAgC;CAChC,uBAAuB;CACvB,gBAAgB;CAChB,gBAAgB;AACjB;AACA;;CAEC,gBAAgB;AACjB;AACA;;CAEC,yBAAyB;AAC1B;AACA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,sBAAsB;AACxB;AACA;;CAEC,qBAAqB;CACrB,sBAAsB;AACvB;AACA;;CAEC,iBAAiB;CACjB,cAAc;CACd,yBAAyB;CACzB,yBAAyB;CACzB,YAAY;CACZ,eAAe;CACf,qBAAqB;CACrB,sBAAsB;CACtB,aAAa;AACd;AACA;;;;;;;;CAQC,0BAA0B;CAC1B,mBAAmB;AACpB;;AAEA;4IAC4I;AAC5I;;CAEC,aAAa;CACb,iBAAiB;CACjB,yBAAyB;CACzB,kBAAkB;CAClB,yBAAyB;CACzB,cAAc;CACd,eAAe;AAChB;AACA;;EAEE,wBAAwB;AAC1B;AACA;;EAEE,aAAa;EACb,eAAe;AACjB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;iDACiD;AACjD;;CAEC,oBAAoB;CACpB,sBAAsB;AACvB;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;CAEC,gBAAgB;CAChB,YAAY;CACZ,UAAU;CACV,cAAc;CACd,0BAA0B;CAC1B,eAAe;CACf,aAAa;AACd;AACA;;CAEC,cAAc;AACf;;AAEA,oCAAoC;AACpC;;CAEC,eAAe;CACf,QAAQ;CACR,qCAAqC;CACrC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,aAAa;AACd;AACA;;CAEC,yBAAyB;CACzB,kBAAkB;CAClB,YAAY;CACZ,6BAA6B;CAC7B,8BAA8B;CAC9B,cAAc;CACd,0CAA0C;CAC1C,sBAAsB;AACvB;AACA;;CAEC,iBAAiB;CACjB,cAAc;CACd,mBAAmB;AACpB;AACA;;CAEC,aAAa;CACb,eAAe;CACf,QAAQ;AACT;AACA;;CAEC,iBAAiB;CACjB,yBAAyB;CACzB,yBAAyB;CACzB,eAAe;AAChB;AACA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;AACA;;CAEC,YAAY;CACZ,eAAe;AAChB;AACA;;CAEC,gBAAgB;AACjB","sourcesContent":["/* Shared styles of the code-review pages; each page imports this file as a scoped style. */\n.crRoot[data-v-b6a2e524]\r\n{\r\n\tpadding: 8px 8px 1em 8px;\r\n\tbackground-color: #EFEDE6;\r\n\toverflow-y: auto;\r\n\tflex: 1 1 auto;\r\n\tmin-width: 0;\r\n\tfont-size: 14px;\n}\n.pageHeading[data-v-b6a2e524]\r\n{\r\n\tfont-size: 28px;\r\n\tmargin: 0 0 0.25em 0;\r\n\tfont-weight: normal;\n}\n.secondaryHeading[data-v-b6a2e524]\r\n{\r\n\tfont-size: 18px;\r\n\tmargin: 0 0 0.4em 0;\r\n\tfont-weight: bold;\n}\n.tabs[data-v-b6a2e524]\r\n{\r\n\tdisplay: flex;\r\n\tgap: 4px;\r\n\tmargin-bottom: 8px;\n}\n.tabs a[data-v-b6a2e524]\r\n\t{\r\n\t\tpadding: 4px 12px;\r\n\t\tborder: 1px solid #AAAAAA;\r\n\t\tbackground-color: #E8E8E8;\r\n\t\tcolor: #000000;\r\n\t\ttext-decoration: none;\n}\n.tabs a.router-link-exact-active[data-v-b6a2e524],\r\n\t\t.tabs a.active[data-v-b6a2e524]\r\n\t\t{\r\n\t\t\tbackground-color: #FFFFFF;\r\n\t\t\tfont-weight: bold;\n}\n.card[data-v-b6a2e524]\r\n{\r\n\tborder: 1px solid #DDDDDD;\r\n\tpadding: 10px 12px;\r\n\tbackground-color: #FFFFFF;\r\n\tmargin-bottom: 10px;\r\n\tbox-shadow: 1px 1px 2px rgba(0,0,0,0.3);\n}\n.errorBox[data-v-b6a2e524]\r\n{\r\n\tbackground-color: #FFE0E0;\r\n\tborder: 1px solid #C00000;\r\n\tcolor: #660000;\r\n\tpadding: 6px 10px;\r\n\tmargin: 6px 0;\r\n\twhite-space: pre-wrap;\r\n\tword-break: break-word;\n}\n.warningBox[data-v-b6a2e524]\r\n{\r\n\tbackground-color: #FFEFC9;\r\n\tborder: 1px solid #E0B93F;\r\n\tcolor: #5C3D00;\r\n\tpadding: 6px 10px;\r\n\tmargin: 6px 0;\n}\n.hintText[data-v-b6a2e524]\r\n{\r\n\tcolor: #505050;\r\n\tfont-size: 0.92em;\n}\n.row[data-v-b6a2e524]\r\n{\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tgap: 6px 10px;\r\n\talign-items: center;\r\n\tmargin: 4px 0;\n}\n.loadingInline[data-v-b6a2e524]\r\n{\r\n\tdisplay: inline-flex;\r\n\talign-items: center;\r\n\tgap: 8px;\n}\n.badge[data-v-b6a2e524]\r\n{\r\n\tdisplay: inline-block;\r\n\tpadding: 1px 6px;\r\n\tborder-radius: 3px;\r\n\tfont-size: 12px;\r\n\tfont-weight: bold;\r\n\twhite-space: nowrap;\r\n\tborder: 1px solid transparent;\n}\r\n\r\n/* Severity badges: every pair has a contrast ratio of at least 4.5:1. */\n.sevCritical[data-v-b6a2e524]\r\n{\r\n\tbackground-color: #8B0000;\r\n\tcolor: #FFFFFF;\n}\n.sevHigh[data-v-b6a2e524]\r\n{\r\n\tbackground-color: #B33C00;\r\n\tcolor: #FFFFFF;\n}\n.sevMedium[data-v-b6a2e524]\r\n{\r\n\tbackground-color: #FFD24D;\r\n\tcolor: #3A2C00;\r\n\tborder-color: #C9A227;\n}\n.sevLow[data-v-b6a2e524]\r\n{\r\n\tbackground-color: #E4E4E4;\r\n\tcolor: #222222;\r\n\tborder-color: #BBBBBB;\n}\r\n\r\n/* Security findings: a dark badge with a shield, so they stand out from the severity and status colors. */\n.securityBadge[data-v-b6a2e524]\r\n{\r\n\tbackground-color: #2D1457;\r\n\tcolor: #FFFFFF;\r\n\tborder-color: #2D1457;\n}\n.securityBadge[data-v-b6a2e524]::before\r\n\t{\r\n\t\tcontent: \"\\1F6E1\\FE0E\\00A0\";\n}\r\n\r\n/* Status badges. */\n.stFailed[data-v-b6a2e524]\r\n{\r\n\tbackground-color: #B00000;\r\n\tcolor: #FFFFFF;\n}\n.stSafety[data-v-b6a2e524]\r\n{\r\n\tbackground-color: #6A1B9A;\r\n\tcolor: #FFFFFF;\n}\n.stOpen[data-v-b6a2e524]\r\n{\r\n\tbackground-color: #E2ECFA;\r\n\tcolor: #123A70;\r\n\tborder-color: #9DB8D8;\n}\n.stProgress[data-v-b6a2e524]\r\n{\r\n\tbackground-color: #FFF4D6;\r\n\tcolor: #5C3D00;\r\n\tborder-color: #E0B93F;\n}\n.stDone[data-v-b6a2e524]\r\n{\r\n\tbackground-color: #E3F2E3;\r\n\tcolor: #1B5E20;\r\n\tborder-color: #9CC79C;\n}\n.stNeutral[data-v-b6a2e524]\r\n{\r\n\tbackground-color: #EEEEEE;\r\n\tcolor: #333333;\r\n\tborder-color: #BBBBBB;\n}\n.dense[data-v-b6a2e524]\r\n{\r\n\tborder-collapse: collapse;\r\n\twidth: 100%;\r\n\tbackground-color: #FFFFFF;\r\n\tfont-size: 13px;\n}\n.dense th[data-v-b6a2e524],\r\n\t.dense td[data-v-b6a2e524]\r\n\t{\r\n\t\tborder-bottom: 1px solid #E2E2E2;\r\n\t\tpadding: 3px 6px;\r\n\t\ttext-align: left;\r\n\t\tvertical-align: top;\n}\n.dense th[data-v-b6a2e524]\r\n\t{\r\n\t\tbackground-color: #F0F0F0;\r\n\t\tposition: sticky;\r\n\t\ttop: 0;\r\n\t\twhite-space: nowrap;\r\n\t\tz-index: 1;\n}\n.dense tbody tr.clickable[data-v-b6a2e524]\r\n\t{\r\n\t\tcursor: pointer;\n}\n.dense tbody tr.clickable[data-v-b6a2e524]:hover\r\n\t\t{\r\n\t\t\tbackground-color: #F4F8FF;\n}\n.nowrap[data-v-b6a2e524]\r\n{\r\n\twhite-space: nowrap;\n}\n.mono[data-v-b6a2e524]\r\n{\r\n\tfont-family: Consolas, monospace;\n}\n.fileCell[data-v-b6a2e524]\r\n{\r\n\tfont-family: Consolas, monospace;\r\n\toverflow-wrap: anywhere;\r\n\tmin-width: 200px;\r\n\tmax-width: 360px;\n}\n.titleCell[data-v-b6a2e524]\r\n{\r\n\tmin-width: 220px;\n}\n.infoTable[data-v-b6a2e524]\r\n{\r\n\tborder-collapse: collapse;\n}\n.infoTable th[data-v-b6a2e524]\r\n\t{\r\n\t\ttext-align: left;\r\n\t\tpadding: 2px 14px 2px 0;\r\n\t\tfont-weight: normal;\r\n\t\tcolor: #444444;\r\n\t\tvertical-align: top;\r\n\t\twhite-space: nowrap;\n}\n.infoTable td[data-v-b6a2e524]\r\n\t{\r\n\t\tpadding: 2px 0;\r\n\t\tword-break: break-word;\n}\n.preText[data-v-b6a2e524]\r\n{\r\n\twhite-space: pre-wrap;\r\n\tword-break: break-word;\n}\n.scrollPre[data-v-b6a2e524]\r\n{\r\n\tmax-height: 400px;\r\n\toverflow: auto;\r\n\tbackground-color: #F7F7F7;\r\n\tborder: 1px solid #DDDDDD;\r\n\tpadding: 8px;\r\n\tfont-size: 12px;\r\n\twhite-space: pre-wrap;\r\n\tword-break: break-word;\r\n\tmargin: 4px 0;\n}\nbutton[data-v-b6a2e524]:focus-visible,\r\na[data-v-b6a2e524]:focus-visible,\r\ninput[data-v-b6a2e524]:focus-visible,\r\nselect[data-v-b6a2e524]:focus-visible,\r\ntextarea[data-v-b6a2e524]:focus-visible,\r\nsummary[data-v-b6a2e524]:focus-visible,\r\ntr[data-v-b6a2e524]:focus-visible\r\n{\r\n\toutline: 2px solid #1A5FB4;\r\n\toutline-offset: 1px;\n}\r\n\r\n/* Action buttons, color-coded by kind (the label always says what it does; the color only groups):\r\n   danger = closes or dismisses, positive = resolves or approves, caution = starts autonomous work now, assist = AI help, plain = neutral. */\n.crAction[data-v-b6a2e524]\r\n{\r\n\tfont: inherit;\r\n\tpadding: 3px 10px;\r\n\tborder: 1px solid #8A8A8A;\r\n\tborder-radius: 4px;\r\n\tbackground-color: #F2F2F2;\r\n\tcolor: #1A1A1A;\r\n\tcursor: pointer;\n}\n.crAction[data-v-b6a2e524]:hover:not(:disabled)\r\n\t{\r\n\t\tfilter: brightness(0.94);\n}\n.crAction[data-v-b6a2e524]:disabled\r\n\t{\r\n\t\topacity: 0.55;\r\n\t\tcursor: default;\n}\n.crAction.danger[data-v-b6a2e524]\r\n\t{\r\n\t\tbackground-color: #F8D7DA;\r\n\t\tborder-color: #B02A37;\r\n\t\tcolor: #58151C;\n}\n.crAction.positive[data-v-b6a2e524]\r\n\t{\r\n\t\tbackground-color: #D1E7DD;\r\n\t\tborder-color: #146C43;\r\n\t\tcolor: #0A3622;\n}\n.crAction.caution[data-v-b6a2e524]\r\n\t{\r\n\t\tbackground-color: #FFF3CD;\r\n\t\tborder-color: #997404;\r\n\t\tcolor: #4D3A02;\n}\n.crAction.assist[data-v-b6a2e524]\r\n\t{\r\n\t\tbackground-color: #DCE8F7;\r\n\t\tborder-color: #2B5797;\r\n\t\tcolor: #0F2A52;\n}\r\n\r\n/* Slide buttons (SlideButton.vue) for actions that are expensive or hard to undo; the handle color gives the kind as above.\r\n   The class sits on the slider's root element. */\n.crSlide[data-v-b6a2e524]\r\n{\r\n\t--su-size-text: 13px;\r\n\t--su-color-bg: #F2F2F2;\n}\n.crSlide[data-v-b6a2e524] .slideunlock-text\r\n\t{\r\n\t\tpadding-left: 30px;\r\n\t\twhite-space: nowrap;\n}\n.linkButton[data-v-b6a2e524]\r\n{\r\n\tbackground: none;\r\n\tborder: none;\r\n\tpadding: 0;\r\n\tcolor: #0B57A6;\r\n\ttext-decoration: underline;\r\n\tcursor: pointer;\r\n\tfont: inherit;\n}\na[data-v-b6a2e524]\r\n{\r\n\tcolor: #0B57A6;\n}\r\n\r\n/* Modal dialogs (reject, prompt). */\n.overlay[data-v-b6a2e524]\r\n{\r\n\tposition: fixed;\r\n\tinset: 0;\r\n\tbackground-color: rgba(0, 0, 0, 0.45);\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tz-index: 1000;\n}\n.dialog[data-v-b6a2e524]\r\n{\r\n\tbackground-color: #FFFFFF;\r\n\tpadding: 14px 16px;\r\n\twidth: 520px;\r\n\tmax-width: calc(100vw - 32px);\r\n\tmax-height: calc(100vh - 32px);\r\n\toverflow: auto;\r\n\tbox-shadow: 2px 2px 8px rgba(0, 0, 0, 0.5);\r\n\tbox-sizing: border-box;\n}\n.dialogLabel[data-v-b6a2e524]\r\n{\r\n\tfont-weight: bold;\r\n\tdisplay: block;\r\n\tmargin: 8px 0 4px 0;\n}\n.reasonButtons[data-v-b6a2e524]\r\n{\r\n\tdisplay: flex;\r\n\tflex-wrap: wrap;\r\n\tgap: 6px;\n}\n.reasonButton[data-v-b6a2e524]\r\n{\r\n\tpadding: 4px 10px;\r\n\tborder: 1px solid #888888;\r\n\tbackground-color: #F4F4F4;\r\n\tcursor: pointer;\n}\n.reasonButton.selected[data-v-b6a2e524]\r\n\t{\r\n\t\tbackground-color: #123A70;\r\n\t\tborder-color: #123A70;\r\n\t\tcolor: #FFFFFF;\n}\n.resizable[data-v-b6a2e524]\r\n{\r\n\tresize: both;\r\n\tmin-height: 4em;\n}\n.dialogButtons[data-v-b6a2e524]\r\n{\r\n\tmargin-top: 10px;\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
